import React, { useEffect, useState } from 'react';
import { FaChevronRight, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setDrawerOpen } from '../../store/global';
import { linkWithMJparam } from '../../utils/roles';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';
import { fetchImage } from '../../utils/img';
import { getAvatarBackgroundStyle, getItemPicAsset } from '../../utils/item';
import { renderIconBySlug } from '../../content/icons';

export const LinkOneLine = props => {
  const { linkId, deleteLink } = props;

  const link = useSelector(state => state.items[linkId]);
  const items = useSelector(state => state.items);
  const canMj = isMjForItem(link, items) || canUseMjForItem(link, items);
  const mjQuery = isMjForItem(link, items) ? '?' + linkWithMJparam() : '';
  const dispatch = useDispatch();
  const [avatar, setAvatar] = useState('');
  const [avatarIconSlug, setAvatarIconSlug] = useState(null);
  const [avatarBgColor, setAvatarBgColor] = useState(null);

  useEffect(() => {
    const avatarAsset = getItemPicAsset(link, 0);
    if (avatarAsset.url) {
      fetchImage(avatarAsset.url, setAvatar);
    } else {
      setAvatar('');
    }
    setAvatarIconSlug(avatarAsset.iconSlug);
    setAvatarBgColor(avatarAsset.bgColor ?? null);
  }, [link]);

  return (
    <div className='flex gap-05 items-center px-1 py-05 flex-1 h-full cursor-pointer'>
      {deleteLink && (
        <div
          className='cursor-pointer transition opacity-50 hover:opacity-100 text-secondary'
          onDoubleClick={e => {
            e.stopPropagation();
            deleteLink(linkId);
          }}
        >
          <FaTimes />
        </div>
      )}
      {(avatarIconSlug || avatar) && (
        <div
          className='rounded-full shadow flex items-center justify-center w-2 h-2'
          style={{
            ...(avatarBgColor
              ? getAvatarBackgroundStyle(avatarBgColor)
              : { backgroundColor: 'rgba(var(--main), 0.5)' }),
          }}
        >
          {avatarIconSlug ? (
            renderIconBySlug(avatarIconSlug, {
              size: 28,
              color: 'var(--contrast)',
            })
          ) : (
            <div
              className='w-full h-full rounded-full'
              style={{
                backgroundImage: `url(${avatar})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            ></div>
          )}
        </div>
      )}
      <div
        onClick={() => {
          dispatch(setDrawerOpen(linkId));
        }}
        className='flex-1 text-condensed font-bold text-lg cursor-pointer'
      >
        {link?.label}
      </div>
      {canMj && (
        <Link
          to={`../../item/${linkId}${mjQuery}`}
          className='cursor-pointer transition hover:opacity-50'
        >
          <FaChevronRight />
        </Link>
      )}
    </div>
  );
};
